module.exports = __webpack_public_path__ + "img/suicide.b74effae.png";